import { BulkPatchSupplierPropertyPreviewRow } from '~/services/BedbankService';

export const SELECTABLE_ACTIONS: Array<BulkPatchSupplierPropertyPreviewRow['action']> = [
  'create',
  're-create',
  'update',
];

export function isSelectableAction(action: BulkPatchSupplierPropertyPreviewRow['action']) {
  return SELECTABLE_ACTIONS.includes(action);
}
